import Layout from "../components/Layout";
import { useState, useEffect, lazy, Suspense } from "react";
import BannerImg from "../assets/images/banner-img.webp";
import WaveImg from "../assets/images/wave_img.svg";
import VideoShape from "../assets/images/video-shape.png";
import GoKartBg from "../assets/img/gokart-bg.webp";
import Logo from "../assets/images/logo.webp";
import MainInstaDown from "../assets/images/main_insta_down_img.svg";
import BannerMobileImg from "../assets/images/mobile-banner-img.webp";
import HomeBookingWidget from "../components/HomeBookingWidget";
import BannerMobileVideo from "../assets/images/mobile-banner-video.mp4";
import BannerDesktopVideo from "../assets/images/main-banner-video.mp4";

import BannerDesktopPoster from "../assets/images/main-banner-poster.jpg";
import BannerMobilePoster from "../assets/images/mobile-banner-poster.jpg";

import TitleShape from "../assets/img/mtfujishape.svg";
import TitleShapeRight from "../assets/img/mtfujishape-right.svg";

import Route1Img from "../assets/img/jdm-route-home.jpg";
import Route2Img from "../assets/img/fuji-route-home.png";
import Route3Img from "../assets/img/helicopter-route-home.png";

import mainDownData from "../assets/images/main_down_data.webp";
import Banner from "../components/Banner";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { FileUrl } from "../config/config";

// FIX (INP): Lazy load all below-the-fold components so they don't block main thread
const Gallery = lazy(() => import("../components/Gallery"));
const Review = lazy(() => import("../components/Review"));
const AdventureCart = lazy(() => import("../components/AdvantureCart"));
const ExperienceSection = lazy(() => import("../components/ExperienceSection"));
const CelebFav = lazy(() => import("../components/CelebFav"));
const MomentSection = lazy(() => import("../components/MomentSection"));
const HomeCta = lazy(() => import("../components/HomeCta"));
const LicencePermit = lazy(() => import("../components/LicencePermit"));
const AdventureExp = lazy(() => import("../components/AdvantureExp"));
const NoteSection = lazy(() => import("../components/NoteSection"));
const TravellerReview = lazy(() => import("../components/TravellerReview"));
const Instagram = lazy(() => import("../components/Instagram"));


const DESKTOP_BREAKPOINT = "(min-width: 1024px)";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false; // safe default for SSR/build
    return !window.matchMedia(DESKTOP_BREAKPOINT).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_BREAKPOINT);
    const handleChange = (e) => setIsMobile(!e.matches);

    // Set correct value on mount (covers hydration / first paint)
    handleChange(mql);

    // Modern browsers
    if (mql.addEventListener) {
      mql.addEventListener("change", handleChange);
      return () => mql.removeEventListener("change", handleChange);
    }
    // Safari <14 fallback
    mql.addListener(handleChange);
    return () => mql.removeListener(handleChange);
  }, []);

  return isMobile;
}

const Home = () => {
  const [loaded, setLoaded] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const isMobile = useIsMobile();

  const [seoData] = useState({
    title: "Best Tokyo Go Kart Tour | 2 Seater Go Kart Japan!",
    meta_desc:
      "Experience real-life go karting in Tokyo with Monkey Adventure Kart! Enjoy 2 seater go karts through Asakusa, Shibuya & Shinagawa for the best go kart tour in Japan.",
  });

  const pageUrl = `${FileUrl}`;

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.meta_desc}
        url={pageUrl}
      />
      <Layout>
        {/* <section id="banner_section"> 
          {isMobile ? (
            <div
              className="relative lg:hidden w-full overflow-hidden"
              style={{ aspectRatio: "9/16" }}
            >
              <video
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                  loaded ? "opacity-100" : "opacity-0"
                }`}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onCanPlay={() => setLoaded(true)}
              >
                <source src={BannerMobileVideo} type="video/mp4" />
              </video>
            </div>
          ) : (
            <div
              className="relative hidden lg:block w-full overflow-hidden "
              style={{ aspectRatio: "16/7" }}
            >
              <video
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                  loaded ? "opacity-100" : "opacity-0"
                }`}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onCanPlay={() => setLoaded(true)}
              >
                <source src={BannerDesktopVideo} type="video/mp4" />
              </video>
            </div>
          )}
        </section> */}
        <section id="banner_section">
          {isMobile ? (
            <div
              className="relative lg:hidden w-full overflow-hidden"
              style={{ aspectRatio: "9/16" }}
            >
              {/* Poster — sits on top, fades out once video is actually playing */}
              <img
                src={BannerMobilePoster}
                alt=""
                className={`absolute inset-0 w-full h-full object-cover z-20 transition-opacity duration-700 ${
                  loaded ? "opacity-0 pointer-events-none" : "opacity-100"
                }`}
              />

              <video
                className="absolute inset-0 w-full h-full object-cover z-10"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onPlaying={() => setLoaded(true)}
              >
                <source src={BannerMobileVideo} type="video/mp4" />
                {/* <source src="/mobile-banner-video.mp4" type="video/mp4" /> */}
              </video>
            </div>
          ) : (
            <div
              className="relative hidden lg:block w-full overflow-hidden"
              style={{ aspectRatio: "16/7" }}
            >
              {/* Poster — sits on top, fades out once video is actually playing */}
              <img
                src={BannerDesktopPoster}
                alt=""
                className={`absolute inset-0 w-full h-full object-cover z-20 transition-opacity duration-700 ${
                  loaded ? "opacity-0 pointer-events-none" : "opacity-100"
                }`}
              />

              <video
                className="absolute inset-0 w-full h-full object-cover z-10"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onPlaying={() => setLoaded(true)}
              >
                <source src="/main-banner-video.mp4" type="video/mp4" />
                {/* <source src={BannerDesktopVideo} type="video/mp4" /> */}
              </video>
            </div>
          )}
        </section>

        {/* <Banner /> */}
        <HomeBookingWidget />

        {/* ─── GO KART COMPANY SECTION ─────────────────────────────────────
            FIX (CLS): GoKartBg image had no width/height — added both.
            FIX: Changed class= to className= throughout (React requirement).
        ──────────────────────────────────────────────────────────────────── */}
        <section className="go_kart_company_section md:pt-[60px] pt-[30px] md:pb-[150px] pb-[400px]  relative overflow-hidden">
          <img
            src={WaveImg}
            alt="" /* decorative — empty alt is correct */
            aria-hidden="true"
            className="absolute wave_img bottom-[-1px] w-full"
            width="1440" /* FIX (CLS) */
            height="120" /* FIX (CLS) */
          />
          <div className="container mx-auto 2xl:px-0 lg:px-[25px] px-[15px]">
            <div className="grid grid-cols-12 items-center gap-4">
              <div className="lg:col-span-6 col-span-12">
                <div className="content_box pb-[50px]">
                  <h2 className="caveat_font main-title text-[30px] mb-[5px] text-[#FBBA00]">
                    #No.1 Go Kart company in Japan
                  </h2>
                  <div className="main-heading-part pb-[30px]">
                    <h1 className="main-heading text-white mb-[20px] md:text-[32px] text-[20px] md:leading-[50px] leading-[30px] font-bold">
                      Unleash the Excitement of Go-Kart in Tokyo with Monkey
                      Adventure Kart
                    </h1>
                    <p className="normal-text text-white md:w-[70%] mb-0 font-[200] lg:text-[16px] text-[14px] md:leading-[28px] leading-[24px]">
                      Welcome to Monkey Adventure Kart - your gateway to the
                      most exciting Go-kart experience in Tokyo! Our mission is
                      to provide you with an unforgettable Adventure through the
                      bustling streets of Tokyo, where you can feel the thrill
                      of real road Go-karting.
                    </p>
                  </div>
                  <div className="button_box flex items-center gap-2">
                    <Link
                      to="/about"
                      className="line-btn text-[16px] text-white"
                    >
                      Learn More
                      <FaArrowRightLong className="text-white inline-block pl-[5px] font-bold text-[22px]" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FIX (CLS): Added width + height so browser reserves space */}
          <div className="go-kart-part-img md:w-[40%] absolute top-0 right-0 h-full z-[-1] md:left-auto left-0 w-full">
            <img
              src={GoKartBg}
              alt="Go kart background"
              className="w-full h-full object-cover"
              width="576" /* FIX (CLS) */
              height="600" /* FIX (CLS) */
              loading="lazy" /* below the fold — lazy is correct here */
            />
          </div>
        </section>

        {/* ─── BELOW-THE-FOLD SECTIONS ─────────────────────────────────────
            FIX (INP): All wrapped in Suspense — they now load as separate
            chunks and don't block the main thread on initial paint.
        ──────────────────────────────────────────────────────────────────── */}
        <section className="lg:py-[100px] py-[50px]">
          <div className="container mx-auto 2xl:px-0 lg:px-[25px] px-[15px] relative">
            <div className="grid grid-cols-12 gap-4 lg:mb-10 mb-5">
              <div className="lg:col-span-3 md:col-span-2 col-span-12 md:block hidden">
                <div className="relative flex items-center justify-end">
                  <img src={TitleShape} />
                </div>
              </div>
              <div className="lg:col-span-6 md:col-span-8 col-span-12">
                <div className="main-heading-part lg:mb-0 mb-4 text-center">
                  <h2 className="main-heading lg:text-[32px] text-[20px] font-bold text-[#121212] lg:mb-2  lg:leading-[50px] leading-[24px]">
                    Experience the Legend of Japan.
                  </h2>
                  <p className="normal-text lg:text-base text-sm text-[#606060] lg:leading-[28px] leading-[22px] mb-0 font-extralight ">
                    Experience the{" "}
                    <span className="italic text-[#D6250C]">Mount Fuji</span> in
                    Style, Elevate your Tokyo adventure to new heights with{" "}
                    <span className="italic text-[#D6250C]">
                      Helicopter Ride
                    </span>{" "}
                    experience, discover authentic{" "}
                    <span className="italic text-[#D6250C]">JDM</span> culture,
                    capture unforgettable photos, and create memories you’ll
                    never forget.
                  </p>
                </div>
              </div>
              <div className="lg:col-span-3 md:col-span-2 col-span-12  md:flex hidden">
                <div className="relative flex items-center">
                  <img src={TitleShapeRight} />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="lg:col-span-4 col-span-12">
                <a
                  href="/jdm-tour-tokyo"
                  className="group block relative main-route-box h-full rounded-[12px] overflow-hidden border border-[#AFBAC7] w-full transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-[#442202] cursor-pointer"
                >
                  <div className="route-img overflow-hidden block">
                    <img
                      src={Route1Img}
                      alt="Route 1"
                      className="w-full transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>

                  <div className="route-content pb-[40px] lg:p-3 p-2 lg:pb-[70px] pb-[30px]">
                    <p className="route-title lg:text-[20px] text-[18px] font-bold text-[#121212] mb-[10px] transition-colors duration-300 group-hover:text-[#442202]">
                      Nissan GT-R R35
                    </p>

                    <p className="lg:text-[16px] text-[12px] text-[#606060] lg:leading-[24px] leading-[20px] mb-0">
                      Rent the legendary Nissan GT-R R35 and drive it yourself
                      through Tokyo’s streets. This is a self-drive rental,
                      perfect for car lovers. The car seats up to 4 people — 1
                      driver and up to 3 passengers.
                    </p>

                    <div className="absolute bottom-3 lg:left-3 left-2 inline-flex items-center gap-3 font-semibold text-[#442202] transition-all duration-300 group-hover:text-[#442202]">
                      <span>Book Now</span>

                      <span className="transition-transform duration-300 group-hover:translate-x-2">
                        <FaArrowRightLong />
                      </span>
                    </div>
                  </div>
                </a>
              </div>
              <div className="lg:col-span-4 col-span-12">
                <a
                  href="/mt-fuji-tour"
                  className="group block relative main-route-box h-full rounded-[12px] overflow-hidden border border-[#AFBAC7] w-full transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-[#442202] cursor-pointer"
                >
                  <div className="route-img overflow-hidden block">
                    <img
                      src={Route2Img}
                      alt="Mt. Fuji Tour"
                      className="w-full transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>

                  <div className="route-content pb-[40px] lg:p-3 p-2 lg:pb-[70px] pb-[30px]">
                    <p className="route-title lg:text-[20px] text-[18px] font-bold text-[#121212] mb-[10px] transition-colors duration-300 group-hover:text-[#442202]">
                      Mt. Fuji Tour
                    </p>

                    <p className="lg:text-[16px] text-[12px] text-[#606060] lg:leading-[24px] leading-[20px] mb-0">
                      Get ready for an adventure of a lifetime with Monkey
                      Adventure Kart's exclusive Mt. Fuji Tour, where every
                      moment is tailor-made for you and your companions! Step
                      into our spacious Toyota Alphard, perfect for groups of up
                      to six, and embark on a journey that promises
                      awe-inspiring sights and unforgettable experiences.
                    </p>

                    <div className="absolute bottom-3 lg:left-3 left-2 inline-flex items-center gap-3 font-semibold text-[#442202] transition-all duration-300">
                      <span>Book Now</span>

                      <span className="transition-transform duration-300 group-hover:translate-x-2">
                        <FaArrowRightLong />
                      </span>
                    </div>
                  </div>
                </a>
              </div>
              <div className="lg:col-span-4 col-span-12">
                <a
                  href="/helicopter-ride"
                  className="group block relative main-route-box h-full rounded-[12px] overflow-hidden border border-[#AFBAC7] w-full transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-[#442202] cursor-pointer"
                >
                  <div className="route-img overflow-hidden block">
                    <img
                      src={Route3Img}
                      alt="Helicopter Ride"
                      className="w-full transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>

                  <div className="route-content pb-[40px] lg:p-3 p-2 lg:pb-[70px] pb-[30px]">
                    <p className="route-title lg:text-[20px] text-[18px] font-bold text-[#121212] mb-[10px] transition-colors duration-300 group-hover:text-[#442202]">
                      Helicopter Ride
                    </p>

                    <p className="lg:text-[16px] text-[12px] text-[#606060] lg:leading-[24px] leading-[20px] mb-0">
                      Elevate your Tokyo adventure to new heights with Monkey
                      Adventure Kart's exhilarating Helicopter Ride experience!
                      Discover the city like never before as you soar above its
                      iconic landmarks and bustling streets in a thrilling
                      aerial journey.
                    </p>

                    <div className="absolute bottom-3 lg:left-3 left-2 inline-flex items-center gap-3 font-semibold text-[#442202] transition-all duration-300">
                      <span>Book Now</span>

                      <span className="transition-transform duration-300 group-hover:translate-x-2">
                        <FaArrowRightLong />
                      </span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <Suspense fallback={null}>
          <Gallery />
          <Review />
          <AdventureCart />
          <ExperienceSection />
        </Suspense>

        {/* ─── VIDEO SECTION ───────────────────────────────────────────────
            NOTE: This section always plays BannerDesktopVideo regardless of
            device (it isn't behind a hidden/lg:hidden split like the banner
            was), so it wasn't double-downloading. If you'd also like this
            one to serve a lighter file on mobile, say so and I'll wire it
            through the same isMobile flag.
        ──────────────────────────────────────────────────────────────────── */}
        <section className="py-[40px] relative video-section">
          <div className="container mx-auto 2xl:px-0 lg:px-[25px] px-[15px] relative">
            <div className="grid grid-cols-12 gap-4">
              <div className="lg:col-span-2"></div>
              <div className="lg:col-span-8 col-span-12">
                <div className="video-box relative rounded-[12px] overflow-hidden border-[7px] border-[#E6E6E6] w-full h-[475px] my-[50px] mb-[120px]">
                  <video
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500`}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                  >
                    <source src={BannerDesktopVideo} type="video/mp4" />
                  </video>
                </div>
              </div>
              <div className="col-span-2"></div>
            </div>
            <img
              src={VideoShape}
              alt=""
              aria-hidden="true"
              className="video-shape absolute md:bottom-[-50px] bottom-[-40px] md:w-auto w-[230px] left-0"
              width="230" /* FIX (CLS) */
              height="200" /* FIX (CLS) */
              loading="lazy"
            />
          </div>
        </section>

        <Suspense fallback={null}>
          <CelebFav />
          <MomentSection />
          <HomeCta />
          <LicencePermit />
          <AdventureExp />
          <NoteSection />
          <TravellerReview />
          <Instagram />
        </Suspense>

        {/* ─── TOKYO BOTTOM SECTION ────────────────────────────────────────
            FIX (CLS): Logo and bottom image had no explicit dimensions.
        ──────────────────────────────────────────────────────────────────── */}
        <section className="main_tokyo_section relative lg:pt-[200px] lg:pb-[450px] pt-[160px] pb-[250px] border-b-[10px] border-[#442202] bg-[#F0EBDE]">
          <div className="main_insta_down">
            <img
              src={MainInstaDown}
              alt=""
              aria-hidden="true"
              className="absolute w-full tokyo_part top-[-1px]"
              width="1440" /* FIX (CLS) */
              height="160" /* FIX (CLS) */
              loading="lazy"
            />
          </div>
          <div className="container mx-auto 2xl:px-0 lg:px-[25px] px-[15px] relative">
            <div className="main_adv_box text-center relative flex flex-col justify-center items-center z-[1]">
              <div className="main_logo_box mb-[30px]">
                <img
                  alt="Monkey Adventure Kart logo"
                  className="w-[200px]"
                  src={Logo}
                  width="200" /* FIX (CLS) */
                  height="80" /* FIX (CLS) — adjust to real logo height */
                  loading="lazy"
                />
              </div>
              <div className="main-heading-part text-center pb-4">
                <h2 className="main-heading md:text-[32px] text-[20px] font-bold text-[#121212] mb-[7px] lg:leading-[50px] leading-[30px]">
                  Your Tokyo Adventure Starts Here
                </h2>
                <p className="normal-text pb-3 lg:text-base text-sm text-[#606060] leading-[28px] mb-0 font-[200]">
                  Pick your city, choose your costume, hit the streets. Ride
                  now!
                </p>
              </div>
              <a
                className="main_book_btn inline-block bg-[#FBBA00] text-[#442202] font-semibold md:px-[85px] px-[32px] md:py-[10px] py-[8px] text-base rounded-[12px] no-underline"
                href="/asakusa-gokart-route"
              >
                Book Now
              </a>
            </div>
          </div>
          <img
            src={mainDownData}
            alt=""
            aria-hidden="true"
            className="w-full main-data-img absolute bottom-0 left-0 right-0"
            width="1440" /* FIX (CLS) */
            height="300" /* FIX (CLS) — adjust to real image height */
            loading="lazy"
          />
        </section>
      </Layout>
    </>
  );
};

export default Home;
